import { useMemo, useCallback } from 'react';

import Asterisk from '@decisiv/iconix/lib/components/Asterisk';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Message from '@decisiv/ui-components/lib/components/Message';
import Grid from '@decisiv/ui-components/lib/components/Grid';
import { TextField, Select, TextArea } from 'components/Form';
import { useFormContext } from 'react-hook-form';

import { getStatesByCountry } from 'utils/countryRegions';

import { Trans, t } from '@lingui/macro';

import { COUNTRY_OPTIONS } from 'pages/Management/constants';
import { FormContainer } from './styles';

const CLEAR_STATE_SELECT = t`Clear State`;

export default function DepotForm() {
  const { watch, setValue } = useFormContext();
  const countryValue = watch('country');

  const stateOptions = useMemo(
    () => (countryValue ? getStatesByCountry(countryValue) : []),
    [countryValue],
  );

  const handleOnCountryChange = useCallback(() => {
    setValue('state', '');
  }, [setValue]);

  return (
    <FormContainer>
      <Grid.Row>
        <Grid.Column>
          <Flex justifyContent="flex-end">
            <Message color="information" icon={Asterisk}>
              <Trans>Required Fields</Trans>
            </Message>
          </Flex>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <TextField label={t`Account`} name="account" disabled />
      </Grid.Row>
      <Grid.Row>
        <TextField label={t`FMS ID`} name="dmsId" />
      </Grid.Row>
      <Grid.Row>
        <TextArea
          label={t`Notes`}
          name="note"
          maxLength={350}
          style={{ height: '78px' }}
        />
      </Grid.Row>
      <Grid.Row>
        <TextField label={t`Name`} name="name" required />
      </Grid.Row>
      <Grid.Row>
        <TextField label={t`Email`} name="email" required />
      </Grid.Row>
      <Grid.Row>
        <TextField label={t`Address`} name="address" />
      </Grid.Row>
      <Grid.Row>
        <Grid.Column marginLeft={0} paddingLeft={0}>
          <Select
            label={t`Country`}
            name="country"
            options={COUNTRY_OPTIONS}
            onChange={handleOnCountryChange}
            defaultValue=""
            required
          />
        </Grid.Column>
        <Grid.Column marginRight={0} paddingRight={0}>
          <Select
            clearButtonLabel={CLEAR_STATE_SELECT}
            label={t`State`}
            name="state"
            options={stateOptions}
            defaultValue=""
            required
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column marginLeft={0} paddingLeft={0}>
          <TextField label={t`City`} name="city" required />
        </Grid.Column>
        <Grid.Column marginRight={0} paddingRight={0}>
          <TextField label={t`Postal Code`} name="postalCode" />
        </Grid.Column>
      </Grid.Row>
    </FormContainer>
  );
}
